import { trackEvent } from "../../../trackEvent";
import getLinkText from "../../../helpers/getLinkText";

/**
 * Push any download links to datalayer based on the below regex
 */


const test = ({ link }) => /^(?:https?:\/\/[^/]+)?\/(?:\.resources|\.imaging|dam|dam-v2|local\/(?:dam|dam-v2|\.resources|\.imaging)|author\/(?:dam|dam-v2|\.resources|\.imaging))\/.+$/i.test(link);

const push = ({ link, target, e }) => {
  e.preventDefault();
  window.open(link, target.target);

  const fileName = link.split("/").pop();
  const fileFormat = fileName.split(".").pop();

  trackEvent({
    event: "file_download",
    event_type: "download",
    document_name: fileName,
    document_type: fileFormat,
    document_url: link,
    element_text: getLinkText({ link, target }),
  });
}

export default {
  name: "download",
  test,
  push
};